const MODULE_NAME = 'IsoModule';

export const GET_ISO_NAMES_ACTION = `${MODULE_NAME}/GET_ISO_NAMES_ACTION`;
export const GET_ISO_GRADES_ACTION = `${MODULE_NAME}/GET_ISO_GRADES_ACTION`;
export const GET_ISO_VALUES_ACTION = `${MODULE_NAME}/GET_ISO_VALUES_ACTION`;
export const CLEAR_ISO_GRADES_ACTION = `${MODULE_NAME}/CLEAR_ISO_GRADES_ACTION`;
